export type SurveyMetaRow = {
    question_id: string;
    answer_id: string;
    question: string;
    answer: string;
    version_no: number;
};

export type GroupedSurveyOption = {
    answer_id: string;
    answer: string;
};

export type GroupedSurvey = {
    question_id: string;
    question: string;
    options: GroupedSurveyOption[];
};

export type GroupedSurveyMeta = Record<string, GroupedSurvey>;

export function groupSurveyMeta(rows: SurveyMetaRow[] | null | undefined): GroupedSurveyMeta {
    const grouped: GroupedSurveyMeta = {};
    if (!rows || rows.length === 0) return grouped;

    for (const row of rows) {
        const key = row.question_id;
        if (!grouped[key]) {
            grouped[key] = {
                question_id: row.question_id,
                question: row.question,
                options: [],
            };
        }
        if (row.answer_id) {
            grouped[key].options.push({ answer_id: row.answer_id, answer: row.answer });
        }
    }

    return grouped;
}


